/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { useContext } from 'react';
import asyncCallHandler from '../common/utils/AsyncCallHandler';
import {setItem, getItem} from '../common/utils/StorageManager';


import { ACTION_TYPES } from './ActionTypes';
import env from '../common/env';


export const fetchSubjects = (token) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';

    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, 'subject?schoolId='+schoolId, token).then(res => {
            setItem('subjects', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_SUBJECTS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_SUBJECTS, payload: err })
        });
    }

}

export const fetchCourse = (token) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';
    
    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, 'course?schoolId='+schoolId, token).then(res => {
            setItem('courses', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_COURSE, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_COURSE, payload: err })
        });
    }

}
export const fetchYearGroup = (token) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';

    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, 'groupYear?schoolId='+schoolId, token).then(res => {
            setItem('groupYears', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_YEARGROUP, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_YEARGROUP, payload: err })
        });
    }

}



export const fetchAllStudents = (token) => { 
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';

    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, env.STUDENTS+ '?schoolId='+schoolId, token).then(res => {
           setItem('allStudents', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_ALL_STUDENTS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_ALL_STUDENTS, payload: err })
        });
    }

}

export const fetchGroupListForDropDown = (token) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';

    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, env.GROUP + '?schoolId='+schoolId, token).then(res => {
            setItem('groupListForDropDown', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_GROUP, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_GROUP, payload: err })
        });
    }

}


export const updateAuditData = (data) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';
    let token = getItem('accessToken')
     return (dispatch) => {
        return asyncCallHandler(env.COMMON_END_POINT, 'auditData', token, 'put', data).then(res => {
            //console.log('res.data')
        }).catch(err => {
           console.log(err)
        });
    }

}

export const fetchAcademicYear = (token) => {
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';
    
    return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT, 'academicYearAssessment?schoolId='+schoolId, token).then(res => {
			//setItem('academicYearsList', res.data);
            dispatch({ type: ACTION_TYPES.FETCH_ACADEMIC_YEAR, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_ACADEMIC_YEAR, payload: err })
        });
    }

}




